// src/components/common/AlertMessage.jsx
import React from "react";
import "./AlertMessage.css";

const AlertMessage = ({ tipo, mensaje, onCerrar }) => {
  const clase = tipo && ["exito", "error", "info", "advertencia"].includes(tipo) ? tipo : "info";

  return (
    <div className={`alert-message alert-message--${clase}`} role="status">
      <span className="alert-message-text">{mensaje}</span>
      {onCerrar && (
        <button
          type="button"
          className="alert-message-close"
          onClick={onCerrar}
          aria-label="Cerrar mensaje"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default AlertMessage;